import { render, staticRenderFns } from "./customerReview.vue?vue&type=template&id=7ea8e0e6&scoped=true"
import script from "./customerReview.vue?vue&type=script&lang=js"
export * from "./customerReview.vue?vue&type=script&lang=js"
import style0 from "./customerReview.vue?vue&type=style&index=0&id=7ea8e0e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea8e0e6",
  null
  
)

export default component.exports